exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-danger[data-v-e96ad278] {\n  background: #f5f5f5 !important;\n  box-shadow: inherit;\n  color: inherit;\n}\n@media screen and (max-width: 750px) {\n.v-btn[data-v-e96ad278] {\n    min-width: 60px !important;\n    margin: 0 0 0 3px;\n}\n}", ""]);

// exports
